<mat-card>
  <mat-card-header>
    <mat-card-title
      cdkDrag
      cdkDragHandle
      cdkDragRootElement=".cdk-overlay-pane"
    >
      {{ title }}
    </mat-card-title>
  </mat-card-header>

  <!-- Form -->
  <mat-card-content style="margin: 2em 0; max-height: 65vh; overflow: auto">
    @if (formulario) {
      <form
        id="form"
        [formGroup]="formulario"
        (ngSubmit)="enviar()"
        autocomplete="off"
      >
        <mat-form-field>
          <mat-label>Cliente</mat-label>
          <mat-select formControlName="idCliente" required>
            @for (dato of clientes; track dato) {
              <mat-option [value]="dato._id">{{ dato.nombre }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Roles</mat-label>
          <mat-select formControlName="roles" required multiple>
            @for (dato of roles; track dato) {
              <mat-option [value]="dato">{{ dato }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Usuario</mat-label>
          <input
            matInput
            placeholder="Usuario"
            formControlName="usuario"
            required
          />
          @if (formulario.get("usuario")?.hasError("pattern")) {
            <mat-error>
              El nombre de usuario no puede contener "ñ". Use "n" en su lugar.
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Clave</mat-label>
          <input
            matInput
            [type]="hide ? 'password' : 'search'"
            autocomplete="new-password"
            placeholder="Clave"
            formControlName="clave"
            [required]="this.data ? false : true"
          />
          <button
            type="button"
            mat-icon-button
            matSuffix
            (click)="$event.stopPropagation(); hide = !hide"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide"
          >
            <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Nombre</mat-label>
          <input
            matInput
            placeholder="Nombre"
            formControlName="nombre"
            required
          />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Correo Electrónico</mat-label>
          <input
            matInput
            placeholder="Correo Electrónico"
            formControlName="email"
          />
        </mat-form-field>
        <div class="row justify-around align-end gap-10px">
          <mat-form-field>
            <mat-label>Pais</mat-label>
            <mat-select formControlName="pais">
              @for (dato of phoneCodes; track dato) {
                <mat-option [value]="dato.dial_code" [disabled]="dato.disabled">
                  {{ dato.name }} {{ dato.dial_code }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Teléfono</mat-label>
            <input
              class="telefono"
              type="number"
              min="0"
              step="1"
              matInput
              placeholder="11 60606060"
              formControlName="telefono"
            />
          </mat-form-field>
        </div>
        <mat-checkbox
          formControlName="sirenasOnline"
          style="margin-bottom: 1em"
        >
          Ver Sirenas Siempre Online
        </mat-checkbox>
      </form>
    }
  </mat-card-content>

  <mat-divider />

  <!-- Botones -->
  <mat-card-actions class="gap-3" style="margin: 0.5em">
    <button
      class="botonSpinner"
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="!formulario?.valid || loading"
      form="form"
    >
      <div
        class="loadSpinnerButton"
        [style.display]="loading ? 'flex' : 'none'"
      >
        <mat-spinner
          class="mx-2"
          [diameter]="25"
          mode="indeterminate"
          color="warn"
        />
      </div>
      <span [style.display]="loading ? 'none' : 'block'">Guardar</span>
    </button>

    <button mat-raised-button type="button" (click)="close()">Volver</button>
  </mat-card-actions>

  <!-- Progress Bar  -->
  <mat-card-footer>
    <mat-progress-bar [mode]="loading ? 'indeterminate' : 'determinate'" />
  </mat-card-footer>
</mat-card>
